import React from 'react';
import { UIColorProvider } from './src/hooks/use-ui-color';

const WrapWithProvider = ({ element }: { element: any }) => (
  <UIColorProvider>{element}</UIColorProvider>
);

export default WrapWithProvider;
